// extracted by mini-css-extract-plugin
module.exports = {"grid":"style__grid__gtB7H","desc":"style__desc__4JE0O","comment":"style__comment__oLYHr"};